<!--
  -  Copyright (c) Qwoach LLC 2022. All rights reserved.
  -  Unauthorized copying of this file, via any medium is strictly prohibited
  -  Proprietary and confidential
  -  Created by Artem Bogush <artem@qwoach.com> on 14/12/2022
  -->

<template>

	<el-select
		ref="select"
		v-model="selectedValue"
		v-bind="attrsNoListeners"
		:placeholder="placeholder"
		class="qwoach-form input-background input-height qw-select-root"
		:class="{'multiple': attrsNoListeners.multiple}"
		@change="onChange"
		@remove-tag="onRemoveTag">
		<el-option
			v-for="(item, index) in optionsComputed"
			:key="index"
			:label="item.label"
			:value="item.value">
			<slot :item="options[index]" :index="index"/>
		</el-option>
	</el-select>
</template>

<script>

import BaseVModelView from "@/core/components/BaseVModelView.vue";
import {isObject} from "@/utils/helpers";
import {hasInputValue} from "@/core/components/Form/FormValueHelper.js";

export default {
	name: "QwSelect",
	extends: BaseVModelView,
	inheritAttrs: false,

	props: {
		options: {Array, required: true},
		valueKey: {String, default: "value"},
		labelKey: {String, default: "label"},
		placeholder: {String, default: "Select"},
		returnMode: {String, default: "key"} //possible value: "object", "key"
	},

	data() {
		return {
			selectedValue: null
		}
	},

	methods: {


		blur(){
			this.$refs.select.blur()
		},

		onValueChanged(newVal){
			console.log("QwSelect.onIncomingValueChanged: newVal = ", newVal)
			if(hasInputValue(newVal)){
				if(Array.isArray(newVal)){
					this.selectedValue = newVal
						.map(item => this.getSelectedValueSingle(item))
						.filter(item => item !== null)
				} else {
					this.selectedValue = this.getSelectedValueSingle(newVal)
				}
			} else {
				this.selectedValue = null
			}
			// let selectedValue = this.getValue(newVal)
			// if(this.selectedOption && selectedValue === value){
			//
			// }
		},

		getSelectedValueSingle(newVal){
			let key = this.getValue(newVal)
			let index = this.options.findIndex(item => this.getValue(item) === key)
			console.log("QwSelect onValueChanged: index = ", index, ", this.optionsComputed = ", this.optionsComputed, ", this.selectedValue = ", this.selectedValue, ", newVal = ", newVal, ", this.options = ", this.options, ", key = ", key)
			if(index >= 0){
				return this.getValue(this.optionsComputed[index])
			} else if(index < 0){
				console.warn("QwSelect onValueChanged: provided value is not listed in the options nad can't be displayed as default value (yet)")
				return null
			}

		},

		onChange(value) {
			console.log("QwSelect onChange: value = ", value, ", this.options = ", this.options, ", arguments = ", ...arguments)
			if(Array.isArray(value)){
				this.valueData = value.map(index => this.options[index])
			} else {
				this.valueData = this.options[value]
			}
			if(this.returnMode !== "object" && isObject(this.valueData)){
				this.valueData = this.valueData[this.valueKey]
			}
			this.notifyValueChanged()
		},

		onRemoveTag(value){
			console.log("QwSelect onRemoveTag: value = ", value, ", this.options = ", this.options)
			this.$emit("remove-tag", this.options[value])

		},

		getValue(option){
			return (isObject(option) && option[this.valueKey] !== undefined) ? option[this.valueKey] : option
		},
		getLabel(option){
			return (isObject(option) && option[this.labelKey] !== undefined) ? option[this.labelKey] : option
		},
	},

	computed: {
		optionsComputed() {
			let result = []
			if(this.options){
				for(let i = 0; i < this.options.length; ++i){
					let option = this.options[i]
					let label = this.getLabel(option)
					result.push({label: label, value: i})
				}
			}
			return result
		}
	},
}
</script>

<style lang="scss">

.qw-select-root{
	//height: px-to-rem(40);//need to maintain variable height in case of multiple values
	line-height: px-to-rem(40);//2.5rem; //40px
	.el-input{
		//padding: 0.5rem;
	}
	.el-select__tags{
		//padding-bottom: 4px;
		.el-tag--small{
			height: 18px;
		}

		.el-select__input{
			margin-left: 0;
			border: none !important;
		}
	}

	.el-select__selected-item{
		.el-tag{
			border-color: var(--el-tag-border-color);
		}
	}
}

</style>
